'use client'

import dynamic from 'next/dynamic'

export const TicketGenieSnippetClient = dynamic(
  () => import('./index').then(mod => mod.TicketGenieSnippet),
  {
    ssr: false,
  },
)
